import React from "react";
import { i18n } from "../../translate/i18n";

function IconDownload() {
	return (
		<svg className="size-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
			<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
			<polyline points="7 10 12 15 17 10" />
			<line x1="12" y1="15" x2="12" y2="3" />
		</svg>
	);
}

const ModalStepOne = ({ selectedFile, handleSelectedFile, contactsLength, loading }) => (
	<div className="app-import-step-content space-y-4">
		<p className="m-0 text-sm text-default-600 dark:text-default-400">
			{i18n.t("contactsImportModal.stepOne.intro")}
		</p>
		<p className="m-0 text-sm text-default-500 dark:text-default-500">
			{i18n.t("contactsImportModal.stepOne.hint")}
		</p>

			<p className="m-0 text-sm text-red-600 dark:text-red-600">
			{i18n.t("contactsImportModal.stepOne.warning")}
		</p>

		<a
			href="/example.csv"
			download
			className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:underline"
		>
			<IconDownload />
			{i18n.t("contactsImportModal.stepOne.downloadSample")}
		</a>

		<div className="flex flex-col gap-2 sm:flex-row sm:items-stretch">
			<input
				type="text"
				className="form-input min-w-0 flex-1"
				value={selectedFile?.name || ""}
				placeholder={i18n.t("contactsImportModal.stepOne.filePlaceholder")}
				readOnly
				disabled
			/>
			<label className="btn btn-primary shrink-0 cursor-pointer sm:self-stretch">
				{i18n.t("contactsImportModal.stepOne.browse")}
				<input
					type="file"
					accept=".csv"
					className="sr-only"
					onChange={(e) => handleSelectedFile(e.target.files[0])}
				/>
			</label>
		</div>

		<p className="m-0 text-sm font-medium text-default-700 dark:text-default-300">
			{i18n.t("contactsImportModal.stepOne.selectedCount", { count: contactsLength })}
		</p>

		{loading && (
			<div className="app-modal-loading !py-2">
				<div className="app-modal-spinner" />
			</div>
		)}
	</div>
);

export default ModalStepOne;
